import React from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import {Asset, MediaItem} from "../../../../plugins/gatsby-plugin-atollon";
import {Play} from "../../icons";
const TitleContentVideo = ({video, title, image, videoEmbed}) => {
    return (
        <section className='title-video'>
          <div className='title-video__inner' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
              {title && <h2>{parse(title)}</h2>}
              {video && !videoEmbed && <video src={video} autoPlay loop muted playsInline/>}
              {videoEmbed && <MediaItem item={videoEmbed} videoThumbnail={video ? video : null} /> }
              {image && !video && !videoEmbed && <Asset asset={image}/>}
          </div>
        </section>
    )
}

export default TitleContentVideo

export const query = graphql`
fragment TitleVideoProps on DatoCmsTitleVideo {
  ... on DatoCmsTitleVideo {
    id
    video
    videoEmbed {
      ...MediaItemProps
    }
    title
    image {
      ...InternalAssetProps
    }
  }
}
`